let url = window.location.href
let adressUrl = ""
if (url.indexOf("csshop.lcyjfz.com") !== -1) {
  adressUrl = "http://cs.lcyjfz.com"
} else if (url.indexOf("http://shop.lcyjfz.com") !== -1) {
  adressUrl = "http://www.lcyjfz.com"
} else {
  adressUrl = "http://cs.lcyjfz.com"
}

export default adressUrl